import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-i-triangle-down",
  "use": "icon-i-triangle-down-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol viewBox=\"0 0 8 4\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-i-triangle-down\">\n    <title>i-triangle-down</title>\n    <g id=\"icon-i-triangle-down_图标\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-593.000000, -162.000000)\" fill=\"#333333\" fill-rule=\"nonzero\" id=\"icon-i-triangle-down_i-triangle-down\">\n            <polygon points=\"601 162 597 166 593 162\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol